module.exports = __webpack_public_path__ + "static/media/search-normal.db3a8e19.svg";